import { Block } from 'baseui/block';
import { themedUseStyletron } from '../../../theme/customTheme'
import { IDriveOneSpeed } from './types'

// icons
import { FaFan } from "react-icons/fa";
import { Rotate } from '../../../components/Rotate/Rotate';
import { DriveIcon, DriveIconSimple } from '../DriveBase/DriveIcon';

export function SmallPanel(props: IDriveOneSpeed) {
    const [, theme] = themedUseStyletron();

    return (
        <>
            <DriveIconSimple  schema={props.schema} color={props.isOn ? theme.appColors.aggregate.on : theme.appColors.aggregate.off} size='25px' />
            </>
    );
}